<svg
  class="hd-gate-graph"
  [attr.viewBox]="viewBox()"
  role="img"
  [attr.aria-label]="'Poort ' + gate()"
  (wheel)="onWheel($event)"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)"
  (pointerleave)="onPointerLeave()"
  (dblclick)="resetView()"
>
  <g [class.hd-gate-graph__dimmed]="dimmed()">
  @for (branch of scene().branches; track branch.id; let index = $index) {
    <g class="hd-gate-graph__branch">
      <title>{{ lineTexts()[index].number }} — {{ lineTexts()[index].keynote }}</title>

      @for (edge of branch.edgePaths; track edge.layer) {
        <path
          class="hd-gate-graph__edge hd-gate-graph__stroke--{{ edge.layer }}"
          [class.hd-gate-graph__edge--deep]="edge.layer >= 3"
          [attr.d]="edge.d"
          [attr.stroke-width]="[0, 0.7, 0.38, 0.19, 0.1][edge.layer]"
        ></path>
      }

      <path
        class="hd-gate-graph__circles hd-gate-graph__layer--4"
        [attr.d]="branch.baseCirclesPath"
        shape-rendering="optimizeSpeed"
      ></path>
      <path
        class="hd-gate-graph__circles hd-gate-graph__layer--3"
        [attr.d]="branch.toneCirclesPath"
        shape-rendering="optimizeSpeed"
      ></path>

      @for (colour of branch.colours; track colour.id) {
        <g class="hd-gate-graph__colour">
          <title>{{ gate() }} · {{ lineTexts()[index].number }} · kleur {{ colour.num }}</title>
          <circle
            class="hd-gate-graph__layer--2"
            [attr.cx]="colour.x"
            [attr.cy]="colour.y"
            [attr.r]="colour.radius"
          ></circle>
          <text
            class="hd-gate-graph__colour-number"
            [attr.x]="colour.x"
            [attr.y]="colour.y + colour.radius * 0.41"
            [attr.font-size]="font.colourNumber"
          >{{ colour.num }}</text>
        </g>
      }

      <circle
        class="hd-gate-graph__ring hd-gate-graph__stroke--1"
        [attr.cx]="branch.line.x"
        [attr.cy]="branch.line.y"
        [attr.r]="branch.line.radius"
      ></circle>
      <circle
        class="hd-gate-graph__inner hd-gate-graph__inner--1"
        [attr.cx]="branch.line.x"
        [attr.cy]="branch.line.y"
        [attr.r]="innerRadius().line"
      ></circle>

      <text
        class="hd-gate-graph__line-number"
        [attr.x]="lineTexts()[index].x"
        [attr.y]="lineTexts()[index].numberY"
        [attr.font-size]="font.lineNumber"
      >{{ lineTexts()[index].number }}</text>
      @for (row of lineTexts()[index].keynoteLines; track $index) {
        <text
          class="hd-gate-graph__line-keynote"
          [attr.x]="lineTexts()[index].x"
          [attr.y]="row.y"
          [attr.font-size]="row.size"
        >{{ row.text }}</text>
      }
      @for (glyph of lineTexts()[index].glyphs; track glyph.key) {
        <text
          class="hd-gate-graph__glyph"
          [attr.x]="glyph.x"
          [attr.y]="glyph.y"
          [attr.font-size]="glyph.size"
          [attr.fill]="glyph.color"
        ><title>{{ glyph.name }}</title>{{ glyph.char }}</text>
      }
    </g>
  }

  <g class="hd-gate-graph__root">
    <title>Poort {{ gate() }} — {{ keynote1() }}</title>
    <circle
      class="hd-gate-graph__ring hd-gate-graph__stroke--0"
      cx="0"
      cy="0"
      [attr.r]="layoutConfig.radius.gate"
    ></circle>
    <circle
      class="hd-gate-graph__inner hd-gate-graph__inner--0"
      cx="0"
      cy="0"
      [attr.r]="innerRadius().gate"
    ></circle>

    @if (centerIconUrl(); as iconUrl) {
      <image
        class="hd-gate-graph__center-icon"
        [attr.href]="iconUrl"
        [attr.x]="rootText().iconX"
        [attr.y]="rootText().iconY"
        [attr.width]="rootText().iconSize"
        [attr.height]="rootText().iconSize"
        aria-hidden="true"
      ><title>{{ centerName() }}</title></image>
    }

    <text
      class="hd-gate-graph__gate-number"
      x="0"
      [attr.y]="rootText().numberY"
      [attr.font-size]="font.gateNumber"
    >{{ rootText().number }}</text>
    @for (row of rootText().keynoteLines; track $index) {
      <text
        class="hd-gate-graph__gate-keynote"
        [class.hd-gate-graph__gate-keynote--dim]="row.dim"
        x="0"
        [attr.y]="row.y"
        [attr.font-size]="row.size"
      >{{ row.text }}</text>
    }
    @for (glyph of rootText().glyphs; track glyph.key) {
      <circle
        class="hd-gate-graph__glyph-disc"
        [attr.cx]="glyph.x"
        [attr.cy]="glyph.discY"
        [attr.r]="glyph.discR"
      ></circle>
      <text
        class="hd-gate-graph__glyph"
        [attr.x]="glyph.x"
        [attr.y]="glyph.y"
        [attr.font-size]="glyph.size"
        [attr.fill]="glyph.color"
      ><title>{{ glyph.name }}</title>{{ glyph.char }}</text>
    }
  </g>

  <!-- Cijfers in de toon- en basis-bolletjes: enkel wanneer je ver genoeg
       ingezoomd bent dat ze passen, en enkel voor wat in beeld is. -->
  @for (item of deepNumbers(); track item.id) {
    <text
      class="hd-gate-graph__deep-number"
      [attr.x]="item.x"
      [attr.y]="item.y"
      [attr.font-size]="item.size"
    >{{ item.num }}</text>
  }
  </g>

  @if (focusActive() && focus(); as focused) {
    <g class="hd-gate-graph__focus">
      @for (layer of focused.subtree; track layer.layer) {
        <path
          class="hd-gate-graph__edge hd-gate-graph__stroke--{{ layer.layer }}"
          [attr.d]="layer.edges"
          [attr.stroke-width]="[0, 0.7, 0.38, 0.19, 0.1][layer.layer]"
        ></path>
        @if (layer.layer >= 3) {
          <path
            class="hd-gate-graph__circles hd-gate-graph__layer--{{ layer.layer }}"
            [attr.d]="layer.circles"
            shape-rendering="optimizeSpeed"
          ></path>
        }
      }

      @for (colour of focusColours(); track colour.id) {
        <circle
          class="hd-gate-graph__layer--2"
          [attr.cx]="colour.x"
          [attr.cy]="colour.y"
          [attr.r]="colour.radius"
        ></circle>
        <text
          class="hd-gate-graph__colour-number"
          [attr.x]="colour.x"
          [attr.y]="colour.y + colour.radius * 0.41"
          [attr.font-size]="font.colourNumber"
        >{{ colour.num }}</text>
      }

      @for (edge of focused.ancestorEdges; track edge.id) {
        <path
          class="hd-gate-graph__edge hd-gate-graph__stroke--{{ edge.layer }}"
          [attr.d]="edge.d"
          [attr.stroke-width]="[0, 0.7, 0.38, 0.19, 0.1][edge.layer]"
        ></path>
      }

      <!-- Alleen tonen en basissen: de kleurcirkels zijn hierboven al mét hun
           cijfer getekend, en een kaal cirkeltje hier zou dat cijfer bedekken. -->
      @for (node of focused.ancestors; track node.id) {
        @if (node.layer >= 3) {
          <circle
            class="hd-gate-graph__layer--{{ node.layer }}"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.radius"
          ></circle>
        }
      }

      @for (line of focusLines(); track line.branch.id) {
        <circle
          class="hd-gate-graph__ring hd-gate-graph__stroke--1"
          [attr.cx]="line.branch.line.x"
          [attr.cy]="line.branch.line.y"
          [attr.r]="line.branch.line.radius"
        ></circle>
        <circle
          class="hd-gate-graph__inner hd-gate-graph__inner--1"
          [attr.cx]="line.branch.line.x"
          [attr.cy]="line.branch.line.y"
          [attr.r]="innerRadius().line"
        ></circle>
        <text
          class="hd-gate-graph__line-number"
          [attr.x]="line.text.x"
          [attr.y]="line.text.numberY"
          [attr.font-size]="font.lineNumber"
        >{{ line.text.number }}</text>
        @for (row of line.text.keynoteLines; track $index) {
          <text
            class="hd-gate-graph__line-keynote"
            [attr.x]="line.text.x"
            [attr.y]="row.y"
            [attr.font-size]="row.size"
          >{{ row.text }}</text>
        }
        @for (glyph of line.text.glyphs; track glyph.key) {
          <text
            class="hd-gate-graph__glyph"
            [attr.x]="glyph.x"
            [attr.y]="glyph.y"
            [attr.font-size]="glyph.size"
            [attr.fill]="glyph.color"
          ><title>{{ glyph.name }}</title>{{ glyph.char }}</text>
        }
      }

      <circle
        class="hd-gate-graph__ring hd-gate-graph__stroke--0"
        cx="0"
        cy="0"
        [attr.r]="layoutConfig.radius.gate"
      ></circle>
      <circle
        class="hd-gate-graph__inner hd-gate-graph__inner--0"
        cx="0"
        cy="0"
        [attr.r]="innerRadius().gate"
      ></circle>
      @if (centerIconUrl(); as iconUrl) {
        <image
          class="hd-gate-graph__center-icon"
          [attr.href]="iconUrl"
          [attr.x]="rootText().iconX"
          [attr.y]="rootText().iconY"
          [attr.width]="rootText().iconSize"
          [attr.height]="rootText().iconSize"
          aria-hidden="true"
        ><title>{{ centerName() }}</title></image>
      }
      <text
        class="hd-gate-graph__gate-number"
        x="0"
        [attr.y]="rootText().numberY"
        [attr.font-size]="font.gateNumber"
      >{{ rootText().number }}</text>
      @for (row of rootText().keynoteLines; track $index) {
        <text
          class="hd-gate-graph__gate-keynote"
          [class.hd-gate-graph__gate-keynote--dim]="row.dim"
          x="0"
          [attr.y]="row.y"
          [attr.font-size]="row.size"
        >{{ row.text }}</text>
      }

      @for (glyph of rootText().glyphs; track glyph.key) {
        <circle
          class="hd-gate-graph__glyph-disc"
          [attr.cx]="glyph.x"
          [attr.cy]="glyph.discY"
          [attr.r]="glyph.discR"
        ></circle>
        <text
          class="hd-gate-graph__glyph"
          [attr.x]="glyph.x"
          [attr.y]="glyph.y"
          [attr.font-size]="glyph.size"
          [attr.fill]="glyph.color"
        ><title>{{ glyph.name }}</title>{{ glyph.char }}</text>
      }

      @for (item of focusDeepNumbers(); track item.id) {
        <text
          class="hd-gate-graph__deep-number"
          [attr.x]="item.x"
          [attr.y]="item.y"
          [attr.font-size]="item.size"
        >{{ item.num }}</text>
      }

      <circle
        class="hd-gate-graph__focus-ring"
        [attr.cx]="focused.ancestors[focused.ancestors.length - 1].x"
        [attr.cy]="focused.ancestors[focused.ancestors.length - 1].y"
        [attr.r]="focused.ancestors[focused.ancestors.length - 1].radius + 1.6"
      ></circle>
    </g>
  }

  @if (highlightActive()) {
    <g class="hd-gate-graph__highlight">
      @for (edge of highlight().edges; track edge.id) {
        <path
          class="hd-gate-graph__casing"
          [attr.d]="edge.d"
          [attr.stroke-width]="edge.casingWidth"
        ></path>
      }
      @for (node of highlight().nodes; track node.id) {
        @if (node.layer >= 2) {
          <circle
            class="hd-gate-graph__casing-dot"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.haloRadius"
          ></circle>
        }
      }
      @for (edge of highlight().edges; track edge.id) {
        <path
          class="hd-gate-graph__highlight-edge"
          [attr.d]="edge.d"
          [attr.stroke]="edge.color"
          [attr.stroke-width]="edge.width"
        ></path>
      }
      <!-- De opgelichte cirkels worden onverzwakt hertekend: alleen de RAND is
           zwart of rood, de inhoud houdt haar eigen laagkleur en tekst. -->
      @for (node of highlight().nodes; track node.id) {
        @if (node.layer >= 3) {
          <circle
            class="hd-gate-graph__layer--{{ node.layer }}"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.radius"
          ></circle>
        }
      }

      @for (item of highlightDeepNumbers(); track item.id) {
        <text
          class="hd-gate-graph__deep-number"
          [attr.x]="item.x"
          [attr.y]="item.y"
          [attr.font-size]="item.size"
        >{{ item.num }}</text>
      }

      @for (colour of highlightedColours(); track colour.id) {
        <circle
          class="hd-gate-graph__layer--2"
          [attr.cx]="colour.x"
          [attr.cy]="colour.y"
          [attr.r]="colour.radius"
        ></circle>
        <text
          class="hd-gate-graph__colour-number"
          [attr.x]="colour.x"
          [attr.y]="colour.y + colour.radius * 0.41"
          [attr.font-size]="font.colourNumber"
        >{{ colour.num }}</text>
      }

      @for (entry of highlightedLines(); track entry.branch.id) {
        <circle
          class="hd-gate-graph__ring hd-gate-graph__stroke--1"
          [attr.cx]="entry.branch.line.x"
          [attr.cy]="entry.branch.line.y"
          [attr.r]="entry.branch.line.radius"
        ></circle>
        <circle
          class="hd-gate-graph__inner hd-gate-graph__inner--1"
          [attr.cx]="entry.branch.line.x"
          [attr.cy]="entry.branch.line.y"
          [attr.r]="innerRadius().line"
        ></circle>
        <text
          class="hd-gate-graph__line-number"
          [attr.x]="entry.text.x"
          [attr.y]="entry.text.numberY"
          [attr.font-size]="font.lineNumber"
        >{{ entry.text.number }}</text>
        @for (row of entry.text.keynoteLines; track $index) {
          <text
            class="hd-gate-graph__line-keynote"
            [attr.x]="entry.text.x"
            [attr.y]="row.y"
            [attr.font-size]="row.size"
          >{{ row.text }}</text>
        }
        @for (glyph of entry.text.glyphs; track glyph.key) {
          <text
            class="hd-gate-graph__glyph"
            [attr.x]="glyph.x"
            [attr.y]="glyph.y"
            [attr.font-size]="glyph.size"
            [attr.fill]="glyph.color"
          ><title>{{ glyph.name }}</title>{{ glyph.char }}</text>
        }
      }

      @if (rootHighlighted()) {
        <circle
          class="hd-gate-graph__ring hd-gate-graph__stroke--0"
          cx="0"
          cy="0"
          [attr.r]="layoutConfig.radius.gate"
        ></circle>
        <circle
          class="hd-gate-graph__inner hd-gate-graph__inner--0"
          cx="0"
          cy="0"
          [attr.r]="innerRadius().gate"
        ></circle>
        @if (centerIconUrl(); as iconUrl) {
          <image
            class="hd-gate-graph__center-icon"
            [attr.href]="iconUrl"
            [attr.x]="rootText().iconX"
            [attr.y]="rootText().iconY"
            [attr.width]="rootText().iconSize"
            [attr.height]="rootText().iconSize"
            aria-hidden="true"
          ><title>{{ centerName() }}</title></image>
        }
        <text
          class="hd-gate-graph__gate-number"
          x="0"
          [attr.y]="rootText().numberY"
          [attr.font-size]="font.gateNumber"
        >{{ rootText().number }}</text>
        @for (row of rootText().keynoteLines; track $index) {
          <text
            class="hd-gate-graph__gate-keynote"
            [class.hd-gate-graph__gate-keynote--dim]="row.dim"
            x="0"
            [attr.y]="row.y"
            [attr.font-size]="row.size"
          >{{ row.text }}</text>
        }
        @for (glyph of rootText().glyphs; track glyph.key) {
          <circle
            class="hd-gate-graph__glyph-disc"
            [attr.cx]="glyph.x"
            [attr.cy]="glyph.discY"
            [attr.r]="glyph.discR"
          ></circle>
          <text
            class="hd-gate-graph__glyph"
            [attr.x]="glyph.x"
            [attr.y]="glyph.y"
            [attr.font-size]="glyph.size"
            [attr.fill]="glyph.color"
          ><title>{{ glyph.name }}</title>{{ glyph.char }}</text>
        }
      }

      <!-- Bovenop alles: enkel de rand in de zijde-kleur. -->
      @for (node of highlight().nodes; track node.id) {
        @if (node.split) {
          <path
            class="hd-gate-graph__highlight-border"
            [attr.d]="node.leftPath"
            stroke="#0e0e0e"
            [attr.stroke-width]="node.strokeWidth"
          ></path>
          <path
            class="hd-gate-graph__highlight-border"
            [attr.d]="node.rightPath"
            stroke="#c0392b"
            [attr.stroke-width]="node.strokeWidth"
          ></path>
        } @else {
          <circle
            class="hd-gate-graph__highlight-border"
            [attr.cx]="node.x"
            [attr.cy]="node.y"
            [attr.r]="node.radius"
            [attr.stroke]="node.color"
            [attr.stroke-width]="node.strokeWidth"
          ></circle>
        }
      }
    </g>
  }
</svg>

@if (canHighlight()) {
  <button
    type="button"
    class="hd-gate-graph__highlight-toggle"
    [class.is-active]="highlightEnabled()"
    [attr.aria-pressed]="highlightEnabled()"
    [title]="toggleLabel()"
    (click)="toggleHighlight()"
  >{{ toggleLabel() }}</button>
}
